import FeedbackComponent from './Feedback.vue';

export const feedbackRoutes = {
  path: '/feedback/:documentId?',
  name: 'Feedback',
  component: FeedbackComponent,
  meta: {
    title: 'Feedback',
  },
  props: true,
};
